import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Monitor, Smartphone } from 'lucide-react'

const EXCLUDED_ROUTES = ['/privacy-policy', '/terms-of-service']

const isMobileViewport = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const mobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
  const smallScreen = window.innerWidth < 1024

  return mobileDevice || smallScreen
}

const MobileWarning = () => {
  const { pathname } = useLocation()
  const [isMobile, setIsMobile] = useState(false)
  const isExcludedRoute = useMemo(() => EXCLUDED_ROUTES.includes(pathname), [pathname])

  useEffect(() => {
    const updateViewportState = () => {
      setIsMobile(isMobileViewport())
    }

    updateViewportState()
    window.addEventListener('resize', updateViewportState)

    return () => {
      window.removeEventListener('resize', updateViewportState)
    }
  }, [])

  if (!isMobile || isExcludedRoute) {
    return null
  }

  return (
    <div className="fixed inset-0 bg-gray-900 z-50 flex items-center justify-center">
      <div className="bg-white shadow-2xl h-full w-full p-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
              <Monitor className="w-10 h-10 text-orange-600" />
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Vui long su dung Laptop hoac PC
          </h3>

          <p className="text-gray-600 mb-8 text-lg">
            OVC Mailer yeu cau man hinh lon de hoat dong toi uu.
            Vui long truy cap tu laptop hoac may tinh de ban de su dung ung dung.
          </p>

          <div className="flex items-center justify-center space-x-6 mb-8">
            <div className="flex flex-col items-center">
              <Smartphone className="w-12 h-12 text-red-500 mb-3" />
              <span className="text-sm text-gray-700 font-medium">Dien thoai</span>
              <span className="text-sm text-red-500 font-semibold">Khong ho tro</span>
            </div>

            <div className="w-12 h-px bg-gray-300" />

            <div className="flex flex-col items-center">
              <Monitor className="w-12 h-12 text-green-600 mb-3" />
              <span className="text-sm text-gray-700 font-medium">Laptop/PC</span>
              <span className="text-sm text-green-600 font-semibold">Duoc ho tro</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileWarning
